import React from 'react';
import usePushNotifications from '../hooks/usePushNotifications';

// Body of the "Notifications" card on the patient settings page: opt this device
// in or out of push notifications. Styling comes from index.css classes only.
export default function PushNotificationsSection() {
  const { status, busy, error, testSent, enable, disable, sendTest } = usePushNotifications();

  if (status === 'loading' || status === 'unavailable') return null;

  return (
    <div>
      <p className="notice-text">
        Get appointment reminders on this device, even when Previu isn&apos;t open. Notifications never
        include your name, results or other medical details.
      </p>

      {error && <div className="alert alert-error" role="alert">{error}</div>}
      {testSent && <div className="alert alert-success" role="status">Test notification sent.</div>}

      {status === 'needs-install' && (
        <div className="alert alert-info">
          On iPhone, add Previu to your Home Screen first: tap the Share button, choose
          &ldquo;Add to Home Screen&rdquo;, then open Previu from there and come back to this page.
        </div>
      )}
      {status === 'unsupported' && (
        <div className="alert alert-info">This browser doesn&apos;t support notifications.</div>
      )}
      {status === 'denied' && (
        <div className="alert alert-warning">
          Notifications are blocked for Previu. Allow them in your browser or phone settings, then reload this page.
        </div>
      )}

      {status === 'off' && (
        <button type="button" className="btn btn-primary" onClick={enable} disabled={busy}>
          {busy ? 'Turning on…' : 'Turn on notifications'}
        </button>
      )}
      {status === 'on' && (
        <div className="inline-actions">
          <span className="badge badge-active">On for this device</span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={sendTest} disabled={busy}>
            Send a test
          </button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={disable} disabled={busy}>
            Turn off
          </button>
        </div>
      )}
    </div>
  );
}
